import React from "react";
import PropTypes from "prop-types";

// A green (yes) / red (no) segmented toggle. No segmented control existed in the player app
// (only the single-checkbox CheckboxInput), so this is a small shared control - the green/red
// mirrors the methodology's positive/negative colour (Topik goal self-assessment, §6.2a c).
const optionClass = (variant, selected) => {
  const base = `yes-no-toggle__option yes-no-toggle__option--${variant}`;
  return selected ? `${base} yes-no-toggle__option--selected` : base;
};

const YesNoToggle = ({ value, onChange, yesLabel, noLabel, ariaLabel, disabled }) => (
  <div className="yes-no-toggle" role="radiogroup" aria-label={ariaLabel}>
    <button
      type="button"
      role="radio"
      aria-checked={value === true}
      className={optionClass("yes", value === true)}
      onClick={() => onChange(true)}
      disabled={disabled}
    >
      {yesLabel}
    </button>
    <button
      type="button"
      role="radio"
      aria-checked={value === false}
      className={optionClass("no", value === false)}
      onClick={() => onChange(false)}
      disabled={disabled}
    >
      {noLabel}
    </button>
  </div>
);

YesNoToggle.propTypes = {
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  yesLabel: PropTypes.string.isRequired,
  noLabel: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
};

YesNoToggle.defaultProps = {
  value: null,
  ariaLabel: undefined,
  disabled: false,
};

export default YesNoToggle;
